import { updateTables } from "../../../jobs-flow/updateTables";

export const HasStatus = {

    async changeStatus(status, callback=() => {}, params={}) {

        let paramString = '';

        if (Object.keys(params).length) {
            paramString = '?'
            for (const [param, value] of Object.entries(params)) {
                paramString += `${param}=${value}&`;
            }
            paramString = paramString.slice(0, -1);
        }

        return $.ajax({
            url: `${this.urlRoot}/${this.id}/${status}${paramString}`,
            method: "POST",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: (response) => {
                callback(response);
            }
        });
    },
}
